import React, { useRef } from "react";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { usePost, useGet } from "seed/api";
import { Loading } from "seed/helpers";
import l from "components/util/l";
import View from "components/vmisc/auth/Signup.view";

function Signup() {

  const anonymousUserId = sessionStorage.getItem("id");
  const anonymousToken = sessionStorage.getItem("token");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const invitation = searchParams.get("invitation");
  const formikRef = useRef();

  const reqInvitation = useGet("/users/get_invitation_details",
    { "invitation": invitation },
    { includeAuth: false }
  );

  const [callSignup, reqSignup] = usePost("/users/signup", {
    onCompleted: (data) => {
      if (data) {
        sessionStorage.clear();
        sessionStorage.setItem("token", data.key);
        sessionStorage.setItem("id", data.user);
        window.location.replace("/app")
      } else {
        swal(l("¡Registro exitoso!%VB031"),
          l("Bienvenido a Workix, tu aliado en tus procesos digitales, te hemos mandado un correo para verificar tu cuenta%VB032"),
          "success");
        sessionStorage.clear();
        if (formikRef.current) {
          formikRef.current.setFieldValue("email", "");
        }
      }
    },
    onError: (error) => {
      if (error.status == 400) {
        swal("Error de registro", "Debe ingresar un correo electrónico válido para poder registrarse", "error");
      } else if (error.status == 401) {
        swal("Error de registro", "La sesion ha expirado, por favor cierre su navegador y vuelva a intentarlo", "error");
      } else if (error.status == 409) {
        swal("Error de registro", "El correo electrónico ya está en uso, por favor use otro o inicie sesión", "error");
      } else {
        swal("Error de registro", "Ha ocurrido un error, por favor intente de nuevo mas tarde", "error");
      }
    },
    includeAuth: false
  });

  const onSubmit = (values) => {
    callSignup({
      anonymus_user_id: anonymousUserId,
      anonymus_token: anonymousToken,
      ...values
    })
  }

  let requireVerification = false;
  if (reqInvitation.loading) return <Loading />;
  if (reqInvitation.error) requireVerification = true;

  const participant = reqInvitation.data;
  const initialValues = {}
  if (participant) initialValues.email = participant.email;

  const isLoading = reqSignup.loading;
  const error = reqSignup.error ? l("Usuario ya se encuentra registrado%VB033") : null;

  return (
    <View
      initialValues={initialValues}
      error={error}
      isLoading={isLoading}
      formikRef={formikRef}
      onSubmit={onSubmit}
    />
  );
}

export default Signup;